export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: {
    signUp:'साइन अप करें',
    title: 'आपकी सभी डिजिटल संपत्तियों के लिए यूनिवर्सल वॉलेट।',
    submit: 'लॉगिन',
    username: 'कृपया अपना फ़ोन नंबर दर्ज करें',
    password: 'कृपया अपना पासवर्ड दर्ज करें',
    verifycode:'कृपया कैप्चा दर्ज करें',
    forget_password:'पासवर्ड भूल गए हैं?',
    no_account:'आपके पास AuWallet खाता नहीं है?',
    register:'रजिस्टर',
    verifycode_tip:'कृपया कैप्चा दर्ज करें',
    verifycode_error:'अमान्य कैप्चा'
  },
  register:{
    title:'रजिस्टर',
    username:'फ़ोन नंबर',
    get_code:'कोड प्राप्त करें',
    verifycode:'सत्यापन कोड',
    password:'पासवर्ड',
    repeat:'पुष्टि करें',
    invite_code:'कोड आमंत्रित',
    submit:'रजिस्टर',
    registered:'पहले से ही एक खाता है',
    go_login:'लॉग इन करें'
  },
  nologin:{
    cloud_wallet:'क्लाउड वॉलेट',
    cloud1:'शीर्ष सुरक्षा सुरक्षा',
    cloud2:'आय का आनंद लेने के लिए अद्वितीय संपत्ति लाभ, रजिस्टर और सिक्के जमा करें',
    cloud3:'30+ से अधिक मुख्यधारा के सिक्कों और 500+ टोकन का समर्थन करें',
    button1:'रजिस्टर',
    button2:'लॉगिन',
    button_oauth: '2U.Chat के साथ साइन इन करें',
    hd_wallet:'एचडी वॉलेट',
    hd1:'निजी चाबियों का 100% नियंत्रण, अधिक सुनिश्चित संपत्ति',
    hd2:'स्मरक शब्दों का एक-क्लिक आयात, सुविधाजनक और उपयोग में आसान',
    hd3:'30+ से अधिक मुख्यधारा के सिक्कों और 500+ टोकन का समर्थन करें',
    button3:'रजिस्टर',
    button4:'लॉगिन',
    doLogin:"लॉग इन करने के लिए क्लिक करें",
    welcomeTo:"AuWallet में आपका स्वागत है",
  },
  forget:{
    title:'पासवर्ड भूल गए？',
    phone_number:'फोन नंबर',
    verify_code:'सत्यापन कोड',
    password:'पासवर्ड',
    repeat:'फिर से दोहराओ',
    submit:'पुष्टि करें'
  },
  footer:{
    nav1:'बटुआ',
    nav2:'बाजार',
    nav3:'संपत्ति',
    nav4:'खोजो',
    nav5:'मेरे'
  },
  home:{
    total:'कुल संपत्ति',
    invite:'मित्रों को आमंत्रित करें',
    redbag:'लाल पैकेट भेजो',
    exchange:'विनिमय',
    scan:'स्कैन',
    address_book:'पता पुस्तिका',
    notice:'नोटिस',
    setting:'सेटिंग',
    view_mnemonic:'निमोनिक देखें',
    backup_mnemonic:'बैकअप निमोनिक',
    create_wallet:'बटुआ बनाएँ',
    import_wallet:'आयात बटुआ',
    welcome:'स्वागत',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  },
  
  address:{
    new_address:'नया पता',
    name:'नाम',
    address:'पता',
    submit:'बनाएं',
	warning_msg: 'टिप्पणी: यह पता केवल erc20 टोकन प्राप्त कर सकता है. कृपया स्थानान्तरण करने के बेले में गलत चैनल चुनें नहीं करने के लिए ध्य'
  },
  swap:{
    title:'फ़्लैश स्वैप',
    pay:'आपको भुगतान करना चाहिए',
    balance:'उपलब्ध शेष राशि',
    lock_rate:'कृपया इस विनिमय दर को लॉक करने के लिए निम्नलिखित समय के भीतर भुगतान पूरा करें',
    gain:'आपको मिल जायेगा',
    input:'कृपया राशि दर्ज करें',
    tip:'जब आपको प्राप्त होने वाली मुद्रा खाली होती है, तो इसका मतलब है कि स्वैप करने के लिए कोई मुद्रा नहीं है',
    submit:'अभी बदलें',
    choose_coin:'सिक्का चुनें:',
	notice_2ut:'मैंने यह नोटिस पढ़ा है'
  },
  coin:{
    send:'भेजना',
    swap:'विनिमय',
    receive:'प्राप्त करते हैं',
    transactions:'लेनदेन',
    type1:'क्लाउड आउट',
    type2:'क्लाउड इन',
    type3:'विनिमय',
    type4:'वित्तीय',
    type7:'HD आउट',
    type8:'HD में',
    type9:'लाल पैकेट भेजें',
    type10:'लाल पैकेट स्वीकार करें',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'निस्तब्धता...',
    loading:'लोडिंग...',
    no_records:'कोई अभिलेख नहीं',
    wallet:'बटुआ',
    tx_time:'लेन-देन समय',
    tx_id:'आईडी',
    tx_from:'से',
    tx_to:'प्रति',
    tx_memo:'टिप्पणी',
    tx_status1:'असफल',
    tx_status2:'प्रतीक्षा',
    tx_status3:'सफलता',
    tx_status4:'लंबित',

    receive_address:'कृपया प्राप्त पता दर्ज करें',
    balance:'संतुलन',
    fee:'शुल्क',
    send_all:'सब भेजें',
    gas_fee:'गैस शुल्क',
    slow:'धीरे',
    fast:'तेज़',
    send:'भेजना',
    tx_password:'कृपया पेमेंट पासवर्ड डालें',
    tx_remark:'टिप्पणियां (वैकल्पिक)',
    address_book1:'मेघ पता पुस्तिका',
    address_book2:'HD पता पुस्तिका',
    need_pay_pass:'कृपया पहले भुगतान पासवर्ड सेट करें',
    need_pin:'कृपया पिन कोड सेट करने के लिए व्यक्तिगत केंद्र पर जाएं',

    
    set_receive_amount:'प्राप्त राशि सेट करें',
    receive_amount:'राशि प्राप्त करें',
    copy_receive_code:'भुगतान कोड कॉपी करें',
    confirm:'पुष्टि करें',
    cancel:'रद्द करें',
    rcv_address:'पता प्राप्त करना',
    search:'खोज सामग्री दर्ज करें',
    filter:'फिल्टर',
    remove:'निकालना',
    add:'जोड़ें',

    filter1:'सभी मुद्राएं',
    filter2:'जोड़ा गया',
    filter3:'जोड़ा नहीं गया',
    
    notices:'एच.डी. बटुआ नोटिस',
    notices2:'क्लाउड वॉलेट नोटिस',
	only_bitcoin: 'यहाँ मात्र बिटकोइन ट्रान्सेक्शन',
	only_eth: 'यहाँ मात्र ETH ट्रान्सेक्शन',
	only_usdt: 'यहाँ मात्र USDT ERC20 लान्तरण मात्र',
	only_2ut: 'यहाँ मात्र २UT ट्रान्सेक्शन',
	only_u2u: 'u2u कोइन मात्र',
	only_2u: '२U बिन्दु मात्र',
	only_a2u: 'स्थानान्तरण a2u मात्र',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'बाजार',
    coin:'एसेट',
    volume:'आयतन',
    price:'कीमत',
    change:'बदलें (24 एच)'
  },

  discover:{
    title:'डिस्कवर',
    popular:'लोकप्रिय',
    all:'सब'
  },

  my:{
    title:'मेरे',
    notice:'नोटिस',
    login:'लॉगिन करने के लिए क्लिक करें',
    welcome:'AuWallet में आपका स्वागत है',
    invite:'आमंत्रण इनाम',
    news:'डेली एक्सप्रेस',
    contact:'ग्राहक सेवा',
    pin_on:'चालू',
    pin_off:'बंद',
    default_currency:'डिफ़ॉल्ट मुद्रा',
    red_green:'उद्धरण विकल्प',
    option1:'हरे ऊपर लाल नीचे',
    option2:'लाल ऊपर हरा नीचे',
    contract:'सेवा समझौता',
    privacy:'गोपनीयता नीति',
    help:'सहायता केंद्र',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	reenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'बटुआ सेटिंग',
    pay_password:'पे पासवर्ड',
    on:'चालू',
    off:'बंद',
    google:'गूगल सत्यापन',
    security_level:'सुरक्षा स्तर',
    account_name:'खाते का नाम',
    logout:'लॉगआउट',
    register_time:'रजिस्टर का समय',
    level:'बराबर',
    modify_pay_password:'भुगतान पासवर्ड बदलें',
    reset_pay_password:'भुगतान पासवर्ड रीसेट करें',
    reset_tip:'अपनी खाता सुरक्षा के लिए, कृपया अपनी पहचान की पुष्टि के लिए मूल भुगतान पासवर्ड दर्ज करें',
    forget_pay_password:'भुगतान पासवर्ड भूल गए',
    set_pay_password:'भुगतान पासवर्ड सेट करें',
    enter_password:'कृपया पासवर्ड दर्ज करें',
    enter_password2:'कृपया फिर से दर्ज करें',
    vcode:'सत्यापन कोड',
    submit:'पुष्टि करें',
    pay_password_wrong:'आपके द्वारा दर्ज किया गया पासवर्ड गलत है',
    fontSize:'फ़ॉन्ट आकार'
  },
  news:{
    title:'डेली एक्सप्रेस',
    share:'साझा करना',
    good:'अच्छा',
    bad:'बुरा'
  },
  pin:{
    title:'पिन कोड निर्धारित करें',
    desc1:'अपनी संपत्तियों की सुरक्षा के लिए, कृपया पहले एक पिन कोड सेट करें, पिन कोड का उपयोग वॉलेट को अनलॉक करने और सिक्के भेजने के लिए किया जाएगा',
    desc2:'पिन कोड एक स्थानीय पासवर्ड है, कृपया इसे ठीक से रखें, यदि यह खो जाता है, तो इसे पुनर्प्राप्त नहीं किया जा सकता है',
    close:'पिन कोड को बंद करें',
    title2:'पिन की पुष्टि करें',
    tip2_1:'क्या आप अपना पिन कोड भूल गए हैं? वॉलेट का बैकअप लेने के बाद, ऐप को फिर से इंस्टॉल करें और मेमनोनिक वाक्यांश आयात करने के बाद रीसेट करें'
  },
  google:{
    title:'गूगल सत्यापन',
    tip:'Google टू-स्टेप वेरिफिकेशन आपके अकाउंट में सुरक्षा की एक परत जोड़ सकता है। जब आप लॉग इन करते हैं या लेन-देन करते हैं, जब आप अपना पासवर्ड दर्ज करते हैं, तो आपको दो-चरणीय सत्यापन से सत्यापन कोड की भी आवश्यकता होती है',
    help:'Google द्वि-चरणीय सत्यापन का उपयोग कैसे करें',
  },
  security:{
    title:'सुरक्षा स्तर',
    title2:'सुरक्षा स्तर',
    tip:'अपने धन की सुरक्षा के लिए, आपको सिक्के निकालने से पहले और सुरक्षा सेटिंग्स और वास्तविक नाम की जानकारी की आवश्यकता है, और निकासी की सीमा तदनुसार बढ़ जाएगी',
    l3title:'दस्तावेज़ प्रकार चुनें',
    l3tip:'कृपया अपने प्रमाणपत्र जारी करने वाले देश का चयन करें',
    c1:'अमेरिका',
    c2:'चीन मुख्यभूमि',
    c3:'चीन हांगकांग, मकाऊ और ताइवान',
    c4:'दक्षिण कोरिया',
    c5:'जापान',
    c6:'सिंगापुर',
    c7:'अन्य',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'प्रमाणन जानकारी',
    tip:'AuWallet के लिए आवश्यक है कि आप सुरक्षा सत्यापन पास करने के लिए सरकार द्वारा जारी एक फोटो आईडी जमा करें',
    subtitle1:'2यू टोकन (2UT) सब्सक्रिप्शन फॉर्म',
    country:'देश',
    country_hint:'आप किस देश में रहते हैं',
    firstname:'पहला नाम',
    firstname_hint:'आपका पहला नाम',
    surname:'उपनाम',
    surname_hint:'उपनाम',
    birthdate:'जन्मदिन',
    cert_id:'आईडी नंबर ',
    cert_id_hint:'आपका आईडी नंबर',
    id_photo1:'आईडी सामने की तस्वीर',
    id_photo2:'आईडी उल्टा फोटो',
    address:'पता',
    address_hint:'आपका वर्तमान आवास',
    addr_photo:'पते का सबूत',
    asset_photo:'संपत्ति का प्रमाण:',
    subtitle2:'निवेशक योग्यता प्रमाणन',
    tip1:'मैं पुष्टि करता हूं कि मैं निम्नलिखित में से कम से कम एक मानदंड को पूरा करता हूं और जारीकर्ता द्वारा एक योग्य निवेशक के रूप में प्रमाणित किया गया है (यदि लागू हो, तो एक से अधिक का चयन किया जा सकता है)',
    tip2:'नोट (1): निवेश पोर्टफोलियो अचल संपत्ति को छोड़कर प्रतिभूतियों और नकदी को संदर्भित करता है।',
    tip3:'नोट (2): पिछले तीन महीनों में मासिक विवरण, गणना सारांश आदि वाले दस्तावेज़ संलग्न होने चाहिए',
    invest_exp:'निवेश अनुभव',
    other_exp:'अन्य',
    avg_volume:'आयतन',
    avg_volume_hint:'पिछले 12 महीनों में औसत लेन-देन की मात्रा (USD)',
    avg_num:'संख्या',
    avg_num_hint:'पिछले 12 महीनों में लेनदेन की औसत संख्या',
    exp_year:'निवेश साल',
    exp_year_hint:'कितने साल का निवेश का अनुभव',
    net_asset:'शुद्ध संपत्ति',
    net_asset_hint:'शुद्ध संपत्ति मूल्य (USD)',
    risk_tolerance:'जोखिम सहिष्णुता',
    invest_term:'आदर्श निवेश शब्द',
    derivative:'संजात',
    signature:'हस्ताक्षर',
    reset:'रीसेट',
    phone_number:'फोन नंबर',
    submit:'जमा करें',
    option1_1:'व्यक्तिगत या उच्च-निवल-मूल्य वाले व्यक्तिगत निवेशक जिनके पास अपने पति या पत्नी या बच्चों के साथ संयुक्त खाते में कम से कम 20,000 अमेरिकी डॉलर (या समकक्ष) की नकदी और / या प्रतिभूतियों का पोर्टफोलियो है।',
    option1_2:'कंपनी या साझेदारी का निवेश पोर्टफोलियो US$20,000 से कम नहीं है या कुल संपत्ति US$2 मिलियन से कम नहीं है',
    option1_3:'उच्च-निवल-मूल्य वाले व्यक्तिगत निवेशक या कंपनियां या साझेदारियां डी ला ओ रूरलबैंक इंक के साथ एक खाता खोलते हैं और इस मूल्यांकन फॉर्म पर हस्ताक्षर करने के समय 20,000 अमरीकी डालर से कम नहीं है।',
    option2_1:'प्रतिभूति',
    option2_2:'वायदा',
    option2_3:'रखने',
    option2_4:'अन्य (कृपया निर्दिष्ट करें)',
    option3_1:'उच्च',
    option3_2:'मध्यम',
    option3_3:'कम',
    option4_1:'3 साल से ज्यादा',
    option4_2:'1-3 साल',
    option4_3:'1 वर्ष से कम',
    option5_1:'हाँ',
    option5_2:'नहीं'
  },
  envelope:{
    title:'लाल लिफाफा',
    owned:'मेरा लिफ़ाफ़ा',
    amount:'रकम',
    quantity:'मात्रा',
    quantity_hint:'लिफाफा मात्रा',
    generate:'उत्पन्न',
    title2:'लिफाफा भेजें',
    total:'लाल लिफाफा कुल रकम',
    wishes:'इच्छाओं',
    submit:'भुगतान करें',
    enter_pass:'कृपया भुगतान पासवर्ड दर्ज करें',
    choose_path:'डिलीवरी का तरीका चुनें',
    view:'लाल लिफाफा विवरण देखें',
    choose_coin:'सिक्का चुनें',
    need_pay_password:'कृपया भुगतान पासवर्ड पहले सेट करें',
    share:'अपने दोस्तों के साथ लाल लिफाफा साझा करें',
    title3:'लाल लिफाफा रिकॉर्ड्स',
    num:'मात्रा'
  },
  mnemonic:{
    title:'बैकअप वॉलेट Mnemonic',
    tip:'निमोनिक निजी कुंजी है, जो आपकी संपत्ति को नियंत्रित करने की कुंजी है',
    tip1:'1. इसमें 12 अक्षर हैं, कृपया इसे कॉपी करें और इसे सुरक्षित स्थान पर रखें.',
    tip2:'2. 100% आपके द्वारा रखा जाएगा, एक बार खो जाने के बाद इसे पुनः प्राप्त नहीं किया जा सकता है।',
    tip3:'3. मुद्रा प्राप्त करने या इसे अनइंस्टॉल करने से पहले कृपया स्मरणीय वाक्यांश का बैकअप पूरा करना सुनिश्चित करें।',
    backup:'अभी बैकअप लें',
    later:'बाद में करो',
    tip4:'कृपया चारों ओर देखें',
    tip5:'जो कोई भी स्मृति चिन्ह प्राप्त करता है उसका अर्थ है कि उन्होंने आपकी संपत्ति प्राप्त कर ली है। कृपया सुनिश्चित करें कि आसपास कोई नहीं है और कोई कैमरा नहीं है।',
    understand:'समझा',
    title2:'निमोनिक देखें',
    tip6:'आप अन्य डिवाइस पर पेयर करने के लिए मेमोनिक वाक्यांश आयात कर सकते हैं, या क्यूआर कोड को पेयर करने के लिए स्कैन करने के लिए अन्य डिवाइस पर AuWallet वॉलेट का उपयोग कर सकते हैं।.',
    tip7:'कृपया स्क्रीनशॉट न लें! अगर किसी को आपका मुहावरा मिलता है, तो उन्हें आपकी संपत्ति सीधे मिल जाएगी!',
    view_code:'एन्क्रिप्टेड क्यूआर कोड देखें',
    tip8:'क्यूआर कोड को एन्क्रिप्ट करना वॉलेट को नए उपकरणों के साथ जोड़ने की सुविधा प्रदान करना है। कृपया स्क्रीनशॉट न लें और उन्हें सेव न करें, और सुनिश्चित करें कि आसपास कोई अन्य लोग या छिपे हुए कैमरे नहीं हैं।',
    tip9:'यह क्यूआर कोड केवल एयू वॉलेट द्वारा उपयोग किया जा सकता है। स्कैन करते समय, आपको संबंधित महामारी को सफलतापूर्वक आयात करने के लिए आयात किए जाने वाले एपीपी में वर्तमान एपीपी का पिन कोड दर्ज करना होगा।',

    title3:'कृपया AuWallet mnemonic कॉपी करें',
    tip3_1:'वॉलेट को पुनर्स्थापित करने के लिए AuWallet mnemonic वाक्यांश का उपयोग किया जाता है। कृपया निम्नलिखित 12 शब्दों को कागज पर कॉपी करके सुरक्षित स्थान पर रख लें।',
    tip3_2:'कृपया स्क्रीनशॉट न लें! अगर किसी को आपका मुहावरा मिलता है, तो उन्हें आपकी संपत्ति सीधे मिल जाएगी!',
    save:'मैंने इसे सुरक्षित रूप से सहेजा है',

    title4:'कृपया AuWallet स्मरक वाक्यांश की पुष्टि करें',
    tip4_1:'यह सुनिश्चित करने के लिए कि आपने AuWallet स्मृति चिन्ह शब्दों को सही ढंग से कॉपी किया है, कृपया क्रम संख्या से संबंधित शब्द का चयन करें।',
    finish:'खत्म',
    next:'अगला',
    verror:'मान्यता त्रुटि',

    title5:'Mnemonic वॉलेट को पुनर्स्थापित करें',
    tip5_1:'बटुए का जवाब देने के लिए कृपया नीचे दिए गए फॉर्म में स्मरणीय शब्द दर्ज करें। प्रत्येक स्मरक शब्द दर्ज करने के बाद, अगले शब्द पर जाने के लिए "स्पेस" कुंजी दबाएं',
    recover:'रिकवरी शुरू करें',
    ask:'मौजूदा वॉलेट को अधिलेखित करें?',
    tip5_2:"वॉलेट आयात करने से वर्तमान वॉलेट अधिलेखित हो जाएगा। यदि आपने अभी तक बैकअप नहीं लिया है, तो वर्तमान वॉलेट हमेशा के लिए गायब हो जाएगा।",
    tip5_3:'मैंने अपने वर्तमान वॉलेट का बैकअप ले लिया है और ओवरराइट करने के लिए सहमत हूं',
    cancel:'रद्द करें',
    import:'इंपोर्ट करना जारी रखें',
    agree:'कृपया सहमत होना चुनें',
    create_success:'सफलतापूर्वक बनाया गया',
    complete:'कृपया पूरा स्मरक भरें'
  },
  invite:{
    title:'मेरा आमंत्रण',
    total:'आमंत्रण संख्या',
    invite_num:'पंजीकृत मित्रों की संख्या',
    bonus1:'1-स्तर के दोस्त',
    every:'p.p',
    bonus2:'2-स्तर के दोस्त',
    bonus3:'3-स्तर के दोस्त',
    deposit:'सिक्के जमा करने वाले मित्रों की संख्या',
    list:'आमंत्रण सूची',
    subtitle1:'पंजीकरण',
    subtitle2:'जमा',
    no_records:'अभी तक कोई आमंत्रण नहीं'
  },
  lang:{
    set_lang:'भाषा सेट करें',

  },
  setting:{
    tip:"सिस्टम वास्तव में यू.एस. डॉलर में ट्रेड करता है, और सिस्टम स्वचालित रूप से नवीनतम विनिमय दर पर उपयोगकर्ता के कमीशन मूल्य को यू.एस. डॉलर में परिवर्तित करता है। वास्तविक कमीशन मूल्य उपयोगकर्ता के इनपुट मूल्य से थोड़ा अलग हो सकता है"
  },
  send:{
    title:'स्थानांतरण प्रकार',
    t1:'ब्लॉकचेन ट्रांसफर',
    t2:'आंतरिक स्थानांतरण',
  },
  sortable:{
    title:'कस्टम सॉर्ट',
    drag_to_sort:'क्रमबद्ध करने के लिए खींचें',
    currency:'मुद्रा'
  },
  system:{
    flushing:'फ्लशिंग...',
    loading:'लोड हो रहा है...',
    btn1:'पुष्टि करना',
    btn2:'रद्द करें',
    add:'जोड़ें',
    search:'खोज',
    topPullText:'ताज़ा करने के लिए नीचे खींचें',
    topDropText:'रिलीज रिफ्रेश',
    topLoadingText:'लोड हो रहा है...',
    copy_succ:'सफलतापूर्वक कॉपी करें',
    copy_fail:'कॉपी विफल',
    about:'About'
  },
  share:{
    title:'साझा करना',
    download:'AuWallet डाउनलोड करने के लिए स्कैन कोड',
    sharecode:'आमंत्रण कोड (कॉपी करने के लिए क्लिक करें):',
    view_invites:'आमंत्रण की जानकारी देखें',
    copy_link:'प्रतिरूप जोड़ना',
    attention:'ऊपर दिए गए लिंक को कॉपी करें, इसे अपने मोबाइल ब्राउज़र में पेस्ट करें और Au वॉलेट डाउनलोड करने के लिए इसे खोलें।'
  },
  wealth:{
    tit:"संपत्तियां",
    title:'मेरी दौलत',
    title1:'खुदाई',
    title2:'सिक्का योजना',
    hot:'लोकप्रिय सिफारिश',
    plan1:'मांग योजना',
    plan2:'निश्चित योजना',
    annu_return:'वार्षिक रिटर्न',
    in_amount:'इसमें राशि',
    transfer_all:'सब',
    view_rules:'नियम देखें',
    pay_password:'कृपया भुगतान पासवर्ड दर्ज करें',
    asset:'संपदा',
    search:'लेन-देन पूछताछ',
    rules:'नियमों',
    order_time:'आदेश का समय',
    value_date:'मूल्य तारीख',
    expiry_date:'समाप्ति तिथि',
    highlights:'हाइलाइट',
    remaining_quota:'बचा हुआ कोटा',
    buy:'अभी खरीदें',
    ystday_earnings:"कल की कमाई",
    total_earnings:'कुल आय',
    transfer_in:'में',
    transfer_out:'बाहर',
	transfer_outed:'पुनरावृत्ति',
    tran_all:'सब',
    tran_in:'में',
    tran_out:'बाहर',
    tran_earning:'आय प्राप्त करें',
    prod_all:'सब',
    prod1:'पीओएस माइनिंग',
    prod2:'सिक्का योजना',
    curr_all:'सब',
    out_amount_tip:'कृपया हस्तांतरण राशि दर्ज करें',
    send:'भेजना',
    success:'सफलता',
    amount_tip:'कृपया एक राशि दर्ज करें',
  },
  ads:{
    title:'अच्छी खबर',
    content:'U2U को समाप्त किया जा रहा है',
    content2:'2UT Hot selling...',
    buy:'खरीदना',
    plan_name:'U2U नया अंक',
    tip: 'U2U is 10% off!'
  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
  	  fuzhicg:'यशस्वी प्रतिलिपी करा.',
  	  fuzhicc:'प्रतिलिपी असफल.',
  },
  alert:{
  	  cancel:'रद्द करा',
  	  confirm:'पुष्टीकृत करा'
  },
  against:{
		  no100: 'Usdt को 100 के बहुत से होना चाहिए'
	},
	package:{
		  title: 'पैकेज',
		  amount: 'मात्रा',
		  time: 'समय',
		  coin: 'कोइन',
		  price: 'मूल्य',
		  scale: 'स्केल',
		  quantity: 'मात्रा',
		  submit: 'भेजें',
		  total: 'कुल',
		  points: 'बिन्दु',
		  apoints2: 'धन के उपलब्ध आगत',
		  balance: 'संतुलन',
		  apoints: 'उपलब्ध बिन्दु:',
		  abalance: 'उपलब्ध(USDT):',
		  abalance2: 'उपलब्ध(U2U):',
		  import: 'Import',
		  orders: 'क्रम',
		  orders_detail: 'क्रम विवरण',
		  defi: 'DEFI',
		  nopoint: 'उपलब्ध बिन्दु',
		  nobalance: 'पुनरावृत्ति उपलब्ध बैलेंस से बढ़ता है',
		  nologin: 'लागइन मियाद समाप्त है, कृपया फिर लागइन करें.',
		  pay_type: 'पैसा प्रकार'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
}
